import { render, staticRenderFns } from "./home-news-card.vue?vue&type=template&id=70970579&"
import script from "./home-news-card.vue?vue&type=script&lang=ts&"
export * from "./home-news-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports